import React, { useState } from 'react';
import './header.css';
import logo from './Image/Logo.jpg';
import { useAuth } from "./AuthContext";
import { auth, functions } from './firebase';

const Header = ({ setShowActu, setShowCommande, setShowAccueil, setShowQuiSommesNous, setShowContact, setShowCompte, setShowPro }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { user } = useAuth();
  const [mobileCommandeOpen, setMobileCommandeOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const clickActu = () => {
    setShowActu();
    setMenuOpen(false);
  };
  const clickCommande = () => {
    setShowCommande();
    setMenuOpen(false);
  };
  const clickAccueil = () => {
    setShowAccueil();
    setMenuOpen(false);
  };
  const clickQuiSommesNous = () => {
    setShowQuiSommesNous();
    setMenuOpen(false);
  };
  const clickContact = () => {
    setShowContact();
    setMenuOpen(false);
  };
  const clickCompte = () => {
    setShowCompte();
    setMenuOpen(false);
  };
  const clickPro = () => {
    setShowPro();
    setMenuOpen(false);
  };


  return (
    <div className="container">
      <div className="information">
        <div className="u1">
          <div className="titre_header" onClick={clickAccueil}>
            ACCUEIL
          </div>
          <div className="titre_header has-submenu">
            COMMANDE
            {/* Le sous-menu qui apparaitra au survol */}
            <div className="submenu">
              <div className="submenu-item" onClick={clickCommande}>Particulier</div>
              {/*<div className="submenu-item" onClick={clickPro}>Pro</div>*/}
            </div>
          </div>
          <div className="titre_header" onClick={clickActu}>
            NOS ACTUS
          </div>
          <div className="titre_header" onClick={clickQuiSommesNous}>
            QUI SOMMES NOUS
          </div>
          <div className="titre_header" onClick={clickContact}>
            CONTACT
          </div>
          {/*<div className="titre_header" onClick={clickPro}>
            PAGE PRO
          </div>*/}
        </div>
        <div className="profil">
          <div className="titre_header2" onClick={clickAccueil}>
            <img src={logo} alt="Logo" />
          </div>
        </div>
        <div className="menu-icon" onClick={toggleMenu}>
          &#9776;
        </div>
      </div>
      {menuOpen && (
        <div className="dropdown-menu">
          <div className="close-icon" onClick={toggleMenu}>
            ✕
          </div>
          <div className="titre_header" onClick={clickAccueil}>
            ACCUEIL
          </div>
          {/* 👇 NOUVEAU BLOC COMMANDE POUR LE MOBILE 👇 */}
          <div className="titre_header has-submenu" onClick={() => setMobileCommandeOpen(!mobileCommandeOpen)}>
            COMMANDE
            {mobileCommandeOpen && (
              <div className="submenu">
                <div
                  className="submenu-item"
                  onClick={(e) => {
                    e.stopPropagation(); // Empêche le clic de juste fermer/ouvrir "COMMANDE"
                    clickCommande();
                    setMobileCommandeOpen(false); // Réinitialise pour la prochaine fois
                  }}
                >
                  PARTICULIER
                </div>
                <div
                  className="submenu-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    clickPro();
                    setMobileCommandeOpen(false); // Réinitialise pour la prochaine fois
                  }}
                >
                  PRO
                </div>

              </div>
            )}
          </div>
          {/* 👆 FIN DU NOUVEAU BLOC 👆 */}
          <div className="titre_header" onClick={clickActu}>
            NOS ACTUS
          </div>
          <div className="titre_header" onClick={clickQuiSommesNous}>
            QUI SOMMES NOUS
          </div>
          <div className="titre_header" onClick={clickContact}>
            CONTACT
          </div>
          {/*<div className="titre_header" onClick={clickPro}>
            PAGE PRO
          </div>
          */}
          <div className="titre_header mobile-only" onClick={clickCompte}>
            MON COMPTE
          </div>
        </div>
      )}

      <div className="information2">
        {user ? (
          <div className="personne2" onClick={clickCompte}></div>
        ) : (
          <div className="personne" onClick={clickCompte}></div>
        )}
      </div>
    </div>
  );
};

export default Header; 